import { render, staticRenderFns } from "./BaseSwitcher.vue?vue&type=template&id=40df2562&scoped=true&"
import script from "./BaseSwitcher.vue?vue&type=script&lang=ts&"
export * from "./BaseSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSwitcher.vue?vue&type=style&index=0&id=40df2562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df2562",
  null
  
)

export default component.exports